import React from "react";
import CaseStudys from "../index";
import styles from "./styles.module.scss";
import snkollajejewellersbanner from "../../../assets/casestudy/snkollajejewellersbanner.png";
import snkollajejewellers1img from "../../../assets/casestudy/snkollajejewellers1img.png";
import snkollajejewellers2img from "../../../assets/casestudy/snkollajejewellers2img.png";
import snkollajejewellers3img from "../../../assets/casestudy/snkollajejewellers3img.png";

import KumarPhotography from "../../../assets/img/KumarPhotoGraphy.png";
import Mongodbicon from "../../../assets/img/mongodbicon.svg";
import Nodeicon from "../../../assets/img/nodeicon.svg";
import Reacticon from "../../../assets/img/reacticon.svg";
import Expressicon from "../../../assets/img/expressicon.svg";
// import ZEEQRCaseStudy from "../../../assets/casestudy/ZEEQRCaseStudy.webp";
// import Ajtech2ndimg from "../../../assets/casestudy/ajtech2ndimg.webp";
import scienceblue1img from "../../../assets/casestudy/scienceblue1img.png";
import buildalead1img from "../../../assets/casestudy/buildalead1img.png";

const SNKollajeJewellers = () => {
  const caseStudiesB = [
    {
      image: scienceblue1img,
      title: "Science blue",
      category: "Website Design",
      pagelink: "/science-blue",
      link: "https://scienceblue.co.in/",
    },
    {
      image: buildalead1img,
      title: "Build A Lead",
      category: "Website Design",
      pagelink: "/build-a-lead",
      link: "https://darkblue-grouse-908073.hostingersite.com/",
    },
  ];
  const servicesB = [
    { label: "UI & UX Design", link: "https://metasoft.ae/services" },
    { label: "Web Development", link: "https://metasoft.ae/services" },
    { label: "Performance Optimization", link: "https://metasoft.ae/services" },
    { label: "SEO", link: "https://metasoftdm.com/marketing-solutions/seo/" },
  ];
  return (
    <CaseStudys
      title="SNKollajeJewellers"
      caseStudies={caseStudiesB}
      subtitle="Trusted Jewellery Makers Rooted in Mangalore’s Heritage"
      header="Trusted Jewellery Makers Rooted in Mangalore’s Heritage"
      websiteUrl="http://www.snkollajejewellers.com/"
      industry="Jewellery & Precious Metals Retail"
      services={servicesB}
      description={
        <>
          <span>S.N. Kollaje Jewellers </span> Arya Fire & Safety is a trusted
          fire protection company committed to delivering reliable, compliant,
          and high-quality safety solutions for businesses and homes. To
          showcase their expertise and comprehensive range of products and
          services, we developed a clean and professional digital presence that
          reflects their credibility and long-standing commitment to safety. The
          website highlights their equipment, installation services, and
          training programs with clarity, offering users a smooth browsing
          experience that builds trust and makes it easy to explore and
          understand their fire safety offerings.
        </>
      }
      objective={{
        heading:
          "Developing a Modern and Informative Digital Experience for Lighting Solutions",
        content: (
          <>
            <p className={styles.projectText}>
              The objective of the Hilight Lighting Studio website project was
              to create a visually appealing and professional digital presence
              that reflects the brand’s expertise in stylish and functional
              lighting solutions. Our goal was to design a clean, organized
              platform that clearly showcases their range of lighting fixtures,
              custom designs, and installation services. This project aimed to
              communicate Hilight Lighting Studio’s credibility, highlight their
              creativity and years of industry experience, and provide users
              with a seamless browsing experience that simplifies
              discovery—ultimately helping homeowners and businesses find the
              right lighting solutions with confidence while strengthening
              engagement in a competitive interior lighting market.
            </p>
          </>
        ),
      }}
      process={{
        heading: "How We Designed a Professional and Intuitive Website",
        content: (
          <>
            <p className={styles.projectText}>
              The project started with a detailed understanding of Hilight
              Lighting Studio’s brand identity, design philosophy, and the needs
              of clients seeking innovative lighting solutions. Using these
              insights, we crafted a user journey that emphasized inspiration,
              easy exploration, and clear presentation of their diverse product
              range. In the design phase, we focused on elegant layouts,
              high-quality visuals, and intuitive navigation to reflect both
              creativity and professionalism. Development prioritized a
              responsive, fast-loading platform with seamless mobile
              performance, ensuring users could effortlessly browse fixtures,
              view installations, and access service details. Continuous
              feedback and iterative testing ensured the final website delivered
              a polished, engaging, and confidence-building experience for every
              visitor.
            </p>
          </>
        ),
      }}
      impact={{
        heading:
          "How the New Online Presence Boosted Arya Fire & Safety’s Customer Engagement",
        content: (
          <>
            <p className={styles.projectText}>
              The launch of the Arya Fire & Safety website significantly
              enhanced the brand’s digital presence, providing businesses and
              individuals with a clear and trustworthy way to explore fire
              safety solutions. The organized layout, intuitive navigation, and
              well-structured content improved user understanding while
              reinforcing confidence in the brand’s expertise and reliability.
              With faster access to product and service details, seamless mobile
              performance, and an overall smoother browsing experience, the
              website has helped increase user engagement and broaden reach
              within the fire safety market. As a result, the platform now
              serves as a professional and dependable touchpoint that supports
              informed decision-making and strengthens Arya Fire & Safety’s
              brand reputation..
            </p>
          </>
        ),
      }}
      conclusion={{
        heading: "Wrapping Up the Project",
        content: (
          <>
            <p className={styles.projectText}>
              In conclusion, the Arya Fire & Safety website effectively
              reflected the brand’s dedication to reliable, compliant, and
              professional fire protection solutions. By combining a clean,
              organized design with seamless functionality, the platform now
              serves as a powerful tool for showcasing products and services,
              building trust, and guiding users toward informed safety
              decisions. The project not only elevated the brand’s digital
              presence but also reinforced Arya Fire & Safety’s position as a
              credible and dependable partner in the competitive fire safety
              market, supporting ongoing growth and long-term industry
              leadership.
            </p>
          </>
        ),
      }}
      heroImage={snkollajejewellersbanner} // Add the hero image
      projectImage={snkollajejewellers1img}
      projectImage2={snkollajejewellers2img}
      projectImage3={snkollajejewellers3img}
      // Add the project image
      technologies={[
        { name: "MongoDB", icon: Mongodbicon },
        { name: "Node.js", icon: Nodeicon },
        { name: "React", icon: Reacticon },
        { name: "Express.js", icon: Expressicon },
      ]} // Add the technologies used
      timescale="On-going" // Add the timescale
      launchDate="Aug 2025" // Add the launch date
    />
  );
};

export default SNKollajeJewellers;
